export default {
	"xlsxUpload.browse": "Datei hinzufügen …",
	"xlsxUpload.acceptedFiles":
		"Es werden nur .xls- und .xlsx-Dateien unterstützt. Bitte verwenden Sie die mitgelieferte Vorlage.",
} as const;
